import './splashScreen.css'

export const SplashScreen = () => {
    return (
        <div className="splash-screen hc8-bg-base">
            <img
                className="splash-image"
                src={`${process.env.PUBLIC_URL}icon-192.png`}
                alt="MPM Logo"
            />
        </div>
    )
}
